import API from '../../api/api';
import * as actionTypes from '../actionTypes';

function inserimentoPreventivo(valori,codiceBroker,stepCorrente,apiPath,numPratica) {
  return (dispatch) => {
    API.getAxios(apiPath).post('/pratica',{
      numPratica:numPratica,
      codiceBroker: codiceBroker,
      currentStep: stepCorrente,
      datiPratica:valori
    })
      .then(response => {
        //console.log(`Funzione SALVA_PREVENTIVO(): `,response.data);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 'event': 'preventivatore', 'step': `${stepCorrente}`});
        dispatch({type: actionTypes.SAVE_DATA, payload: response.data});
        dispatch({ type: actionTypes.LOADING_FALSE })
        dispatch({type: actionTypes.STEP_AVANTI});
      })
      .catch(errore => {
        dispatch({ type: actionTypes.ERROR_SAVE_DATA, payload: errore.response.data});
        dispatch({ type: actionTypes.LOADING_FALSE });
        })
  };
}

export default inserimentoPreventivo;